document.addEventListener('DOMContentLoaded', () => {

    new window.bootstrap.Tooltip(document.body, {
        selector: '[data-bs-toggle="tooltip"]',
    });

});
